module.exports = __webpack_public_path__ + "img/play.fcc651b7.png";